import { Button } from "../../../components";
import { notification } from "../../../services";

const ImportarTitulosActions = ({
  steps,
  activeStep,
  setActiveStep,
  setLoading,
}) => {
  const ultimoStep = activeStep === steps.length - 1;

  const handleVoltarStep = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const handleAvancarStep = async () => {
    setLoading(true);
    try {
      await steps[activeStep].funcaoAcao();
      if (!ultimoStep) setActiveStep(activeStep + 1);
    } catch (error) {
      notification.alertaGenericos(
        error.message || "Ocorreu um erro inesperado.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleVoltarStep}
        sx={{ width: "130px" }}
        startIcon={
          <i
            className="ph-fill ph-caret-left"
            style={{ color: "#fff", fontSize: 18 }}
          ></i>
        }
        disabled={activeStep === 0}
      >
        Voltar
      </Button>
      {ultimoStep ? (
        <Button
          variant="contained"
          color="success"
          onClick={handleAvancarStep}
          sx={{ width: "135px" }}
        >
          Cadastrar
        </Button>
      ) : (
        <Button
          variant="contained"
          onClick={handleAvancarStep}
          sx={{ width: "135px" }}
          endIcon={
            <i
              className="ph-fill ph-caret-right"
              style={{ color: "#fff", fontSize: 18 }}
            ></i>
          }
        >
          Próximo
        </Button>
      )}
    </>
  );
};

export default ImportarTitulosActions;
